export default __webpack_public_path__ + "static/media/level-gold.10c535ef.svg";